import { defineMessages } from 'react-intl';
import type { FundingStageEnum } from '@foundershub/api-client';

export const fundingStageLabels = defineMessages<FundingStageEnum>({
  'no-funding-self-funded': {
    defaultMessage: 'No Funding / Self-Funded',
    description: 'business/startup funding stage',
  },
  angel: {
    defaultMessage: 'Angel',
    description: 'business/startup funding stage',
  },
  seed: {
    defaultMessage: 'Seed',
    description: 'business/startup funding stage',
  },
  'series-a': {
    defaultMessage: 'Series A',
    description: 'business/startup funding stage',
  },
  'series-b': {
    defaultMessage: 'Series B',
    description: 'business/startup funding stage',
  },
  'series-c': {
    defaultMessage: 'Series C',
    description: 'business/startup funding stage',
  },
  'series-d': {
    defaultMessage: 'Series D+',
    description: 'business/startup funding stage',
  },
});
